// Long-form course descriptions — used by /cours/:slug detail pages.
// Each entry: { intro: string[], bases: string[], why: string[], tagline?: string }

export const COURSE_DETAILS = {
  "hip-hop": {
    tagline: "Né dans les rues du Bronx — une culture, un état d'esprit, un moyen d'expression.",
    intro: [
      "Le Hip-Hop est bien plus qu'un simple style de danse, c'est une culture, un état d'esprit et un moyen d'expression. Né dans les rues du Bronx à New York dans les années 70, il a évolué pour devenir un mouvement artistique influent mêlant danse, musique, graffiti et DJing.",
      "Le Hip-Hop Chorégraphique repose sur une structure claire et progressive, où les danseurs apprennent et perfectionnent des bases solides du hip-hop tout en explorant l'univers des chorégraphies de groupe. Dans ce style, une chorégraphie est construite de A à Z — contrairement au Hip-Hop Freestyle, axé sur l'improvisation.",
    ],
    bases: [
      "Les bases fondamentales du hip-hop",
      "La mémoire chorégraphique et la coordination",
      "L'expressivité et la mise en scène",
      "La gestion de l'espace et du rythme",
      "La connexion avec la musique et les autres danseurs",
    ],
    why: [
      "Développer une technique solide et progressive",
      "Apprendre à danser en groupe et à se synchroniser",
      "Se préparer pour des représentations scéniques",
      "S'amuser tout en progressant",
    ],
  },
  "hip-hop-freestyle": {
    tagline: "L'improvisation, la créativité, le flow personnel.",
    intro: [
      "Le Hip-Hop Freestyle met l'accent sur l'individualité du danseur et son expression personnelle. Contrairement au hip-hop chorégraphique, il ne repose pas sur une séquence de mouvements fixes, mais sur l'improvisation et la créativité.",
      "Permet de s'exprimer physiquement sans mots, en ressentant et en incarnant la musique de manière unique. Essentiel pour apprendre à danser, à réagir en temps réel à la musique, et à se connecter à son propre corps.",
    ],
    bases: [
      "Le développement du ressenti musical",
      "L'apprentissage des bases techniques (bounce, top rock, footwork, waves, isolations…)",
      "La spontanéité et la capacité à improviser",
      "La gestion du corps et du flow personnel",
      "La confiance en soi et l'exploration des émotions à travers le mouvement",
    ],
    why: [
      "Trouve ton flow personnel",
      "Réagis à la musique en temps réel",
      "Connecte-toi à ton corps",
      "Explore tes émotions par le mouvement",
    ],
  },
  "heels": {
    tagline: "La danse en talons — élégance, sensualité, puissance et confiance.",
    intro: [
      "Le Heels, ou danse en talons, est une discipline qui allie élégance, sensualité et technique, tout en mettant l'accent sur la confiance en soi et l'expression corporelle. Inspiré du jazz, du hip-hop et du cabaret, ce style permet d'explorer une gestuelle à la fois féminine, puissante et assumée.",
      "À travers le travail de la marche, de la posture, des ondulations, des lignes du corps et des transitions au sol, les élèves développent leur fluidité, leur assurance et leur présence scénique. Les chorégraphies invitent à lâcher prise, à exprimer sa personnalité et à se sentir pleinement à l'aise dans son corps.",
      "Le Heels est ouvert à tous, quel que soit le niveau. Aucune expérience préalable de la danse ou des talons n'est nécessaire pour commencer.",
    ],
    bases: [
      "Posture et port de tête — se tenir avec élégance et assurance",
      "Marche et déplacements en talons — développer fluidité, stabilité et maîtrise",
      "Ondulations et isolations — explorer une gestuelle sensuelle et contrôlée",
      "Travail au sol et transitions — enchaîner les mouvements avec grâce et fluidité",
      "Expression et confiance en soi — affirmer son style et sa présence scénique",
    ],
    why: [
      "Développe la posture, l'équilibre et la confiance en soi",
      "Permet d'explorer une gestuelle sensuelle et assumée",
      "Renforce la présence scénique, la fluidité et le sens du rythme",
      "Une discipline qui mêle élégance, puissance et plaisir",
    ],
  },
  "mini-girly": {
    tagline: "Un style girly dès 7 ans — fluidité du contemporain, énergie de la street, sans talons.",
    intro: [
      "Le Mini Girly est un cours de danse girly pensé pour les enfants dès 7 ans. Il puise dans les bases de la danse contemporaine — fluidité, gestuelle, conscience du corps — et dans celles de la street dance — groove, rythme et attitude — pour créer un style mixte, actuel et accessible. Le cours se pratique toujours à pieds nus.",
      "À travers des exercices de posture, de coordination, de rythme et de déplacements, les élèves apprennent à mieux connaître leur corps, à gagner en assurance et à développer leur présence scénique. Les chorégraphies suivent les musiques du moment, avec des mouvements accessibles qui privilégient avant tout le plaisir de danser.",
      "Le Mini Girly est ouvert à tous les enfants, quel que soit leur niveau.",
    ],
    bases: [
      "Posture et port de tête — apprendre à se tenir avec élégance et assurance",
      "Gestuelle et fluidité — les bases du contemporain, du bout des doigts jusqu'au regard",
      "Groove et rythme — l'énergie de la street dance, en musique",
      "Coordination et équilibre — mieux contrôler ses mouvements et son corps",
      "Expression et confiance en soi — oser s'affirmer et prendre sa place",
    ],
    why: [
      "Développe la posture, l'équilibre et la coordination",
      "Un style girly mixte, entre contemporain et street dance",
      "Renforce la confiance en soi et la présence scénique",
      "Un cours dynamique mêlant fluidité, rythme et plaisir",
    ],
  },
  "salsa": {
    tagline: "Énergie et dynamisme — le rythme latino dans toute sa puissance.",
    intro: [
      "Originaire de Cuba et des Caraïbes, la salsa est une danse rythmée, festive et pleine de vitalité. Elle mélange des influences africaines, espagnoles et jazz, et se danse sur une musique rapide et entraînante.",
    ],
    bases: [
      "Pas de base dynamique — jeu de pas rapide et fluide sur 8 temps (1-2-3, pause, 5-6-7, pause)",
      "Connexions et tours — passes et tours impressionnants, coordination et écoute du partenaire",
      "Musicalité et improvisation — ressentir les instruments (percussions, cuivres, piano…)",
      "Styles variés — Cubaine (Casino), Portoricaine (On1, On2), Colombienne",
    ],
    why: [
      "Excellente pour l'endurance et le cardio",
      "Style dynamique et joyeux",
      "Développe l'écoute et la connexion avec le partenaire",
      "Se danse dans le monde entier — parfait pour les soirées latines",
    ],
  },
  "dancehall": {
    tagline: "Le groove jamaïcain — fluidité, énergie, attitude.",
    intro: [
      "Le Dancehall est une danse urbaine originaire de Jamaïque, inspirée du reggae et du hip-hop. Dynamique et expressif, ce style se caractérise par des mouvements fluides, un groove naturel et une forte connexion à la musique.",
    ],
    bases: [
      "Un groove naturel et un rebond constant sur la musique",
      "Des pas codifiés — Willy Bounce, Butterfly, Bogle",
      "Une attitude assumée et expressive",
      "Un mélange de fluidité et d'énergie explosive",
    ],
    why: [
      "Une danse festive et dynamique",
      "Développe la confiance en soi et l'attitude",
      "Excellent moyen de ressentir la musique",
      "S'exprimer librement sur le rythme jamaïcain",
    ],
  },
  "girly": {
    tagline: "L'énergie hip-hop avec une touche féminine, stylisée et puissante.",
    intro: [
      "Le Hip-Hop Girly est une danse urbaine qui fusionne l'énergie du hip-hop avec des mouvements plus féminins et stylisés. Inspiré des clips et de la scène actuelle, ce style met en avant l'attitude, la confiance en soi et l'expression personnelle, toujours sur des musiques actuelles et rythmées.",
    ],
    bases: [
      "Un groove marqué et une aisance naturelle sur la musique",
      "Des pas dynamiques inspirés du hip-hop, travaillés avec fluidité et précision",
      "Une attitude affirmée, sensuelle et expressive",
      "Un mélange de puissance, de style et d'élégance",
    ],
    why: [
      "Booste la confiance en soi",
      "Développe la présence scénique",
      "Style moderne et tendance, accessible à toutes et tous",
      "Se défouler et exprimer sa personnalité",
    ],
  },
  "eveil-danse": {
    tagline: "La première rencontre avec la musique et le mouvement (3-5 ans).",
    intro: [
      "L'éveil à la danse est un cours spécialement conçu pour les plus petits. À travers des jeux, des histoires et des musiques variées, les enfants découvrent le mouvement, le rythme et l'espace, tout en développant leur créativité et leur motricité.",
      "Une première approche ludique de la danse qui favorise l'expression et la confiance en soi.",
    ],
    bases: [
      "Découvrir son corps et ses possibilités de mouvement",
      "Développer la motricité, la coordination et le sens du rythme",
      "Apprendre à écouter la musique et à bouger en groupe",
      "Favoriser l'imaginaire et l'expression personnelle à travers la danse",
    ],
    why: [
      "Un moment de découverte joyeux adapté aux tout-petits",
      "Canalise l'énergie et développe la concentration",
      "Excellent moyen d'exprimer sa créativité",
      "Prendre confiance dès le plus jeune âge",
    ],
  },
  "comedie-musicale": {
    tagline: "Danse, chant et théâtre — l'art total de la scène.",
    intro: [
      "La Comédie Musicale est un art complet qui mélange danse, chant et théâtre. Inspirée des grands spectacles de Broadway et des films musicaux, elle permet de vivre pleinement la scène en développant l'expression artistique, la présence et la confiance en soi.",
    ],
    bases: [
      "L'apprentissage de chorégraphies dynamiques et expressives",
      "Le travail de la voix et de l'interprétation en chant",
      "Le jeu théâtral pour incarner un personnage et transmettre des émotions",
      "La combinaison des trois arts de la scène pour raconter une histoire",
    ],
    why: [
      "Discipline complète : danse + chant + théâtre",
      "Développe l'assurance, la créativité et le travail d'équipe",
      "Le plaisir de se glisser dans la peau d'un personnage",
      "Vivre une histoire sur scène",
    ],
  },
  "bachata": null, // removed — no longer offered

  "cours-prives": {
    tagline: "Danse, chant ou théâtre — un accompagnement 100 % personnalisé.",
    intro: [
      "Envie de progresser à ton rythme, dans un cadre totalement personnalisé ? Les cours privés te permettent de travailler la danse, le chant ou le théâtre en tête-à-tête avec un·e professeur, avec un accompagnement adapté à ton niveau, tes objectifs et ton style. Que tu débutes ou que tu souhaites te perfectionner, ce format sur-mesure t'aide à progresser plus vite, dans un cadre bienveillant.",
    ],
    bases: [
      "Un programme sur mesure selon ta discipline (danse, chant ou théâtre)",
      "Un travail technique ciblé sur tes besoins",
      "Un rythme entièrement adapté à ton niveau",
      "Un accompagnement individuel du début à la fin",
    ],
    why: [
      "Un accompagnement 100 % individuel et personnalisé",
      "Progresser plus vite, à son propre rythme",
      "Se sentir libre d'explorer sans jugement",
      "Choisir sa discipline : danse, chant ou théâtre",
    ],
  },

  "zumba": {
    tagline: "La fête latine où le sourire est obligatoire.",
    intro: [
      "La Zumba est un cours de danse-fitness fun et accessible, qui mélange des rythmes latinos (salsa, merengue, reggaeton, cumbia…) avec des mouvements simples et entraînants. Plus qu'un sport, c'est une véritable fête qui permet de se défouler, de brûler des calories et de danser en s'amusant.",
    ],
    bases: [
      "Des chorégraphies simples et accessibles à tous",
      "Mélange de danse et de fitness sur musiques latines et actuelles",
      "Une énergie positive et communicative",
      "Une ambiance festive où le sourire est obligatoire",
    ],
    why: [
      "Entraînement complet : cardio + coordination",
      "Bouger sans pression et sans jugement",
      "Se dépenser et relâcher le stress",
      "Danser avec plaisir",
    ],
  },

  "competition-junior": {
    tagline: "L'esprit d'équipe et la scène compétitive, dès les premières années.",
    callout: {
      title: "Accès sur casting",
      text: "Inscription sous audition. Accès sur casting.",
    },
    intro: [
      "Discipline : hip-hop en compétition · Tranche d'âge : Junior 7–11 ans.",
      "L'équipe Compétition Junior réunit les danseurs sélectionnés pour représenter l'école lors des compétitions régionales et nationales dans la catégorie junior. Les chorégraphies de groupe, travaillées avec exigence et précision, préparent les danseurs à performer face à un jury dans un cadre stimulant et bienveillant.",
    ],
    bases: [
      "Technique et précision de groupe",
      "Synchronisation et musicalité",
      "Endurance et régularité",
      "Gestion du stress de compétition",
    ],
    why: [
      "Représenter l'école en compétition",
      "Progresser au sein d'un groupe motivé",
      "Développer discipline et rigueur",
      "Vivre ses premières expériences de scène compétitive",
    ],
  },

  "competition-varsity": {
    tagline: "Le niveau élite de notre compagnie compétitive.",
    callout: {
      title: "Accès sur casting",
      text: "Inscription sous audition. Accès sur casting.",
    },
    intro: [
      "Discipline : hip-hop en compétition · Tranche d'âge : Varsity 12–16 ans.",
      "L'équipe Compétition Varsity regroupe les danseurs les plus expérimentés de l'école, engagés dans les compétitions de plus haut niveau. Les chorégraphies y sont plus complexes, exigeant technique avancée, endurance et une présence scénique affirmée.",
    ],
    bases: [
      "Technique avancée",
      "Complexité chorégraphique et transitions",
      "Endurance et performance sous pression",
      "Leadership au sein du groupe",
    ],
    why: [
      "Intégrer l'équipe phare de l'école",
      "Se mesurer aux meilleures compagnies",
      "Repousser ses limites techniques",
      "Vivre l'adrénaline des grandes compétitions",
    ],
  },

  "compagnie-junior": {
    tagline: "Représenter l'école, sur scène et en compétition.",
    callout: {
      title: "Accès sur casting",
      text: "Inscription sous audition. Accès sur casting.",
    },
    intro: [
      "Discipline : comédie musicale (chant, danse, théâtre) — pas de compétition hip-hop · Tranche d'âge : Compagnie Junior 7–14 ans.",
      "La Compagnie Junior est le groupe de représentation de l'école pour les jeunes danseurs sélectionnés. Au-delà de la compétition, elle participe aux spectacles, galas et événements de l'école, offrant une expérience scénique complète et un fort esprit de troupe.",
    ],
    bases: [
      "Polyvalence chorégraphique",
      "Travail de troupe et cohésion",
      "Présence scénique et performance",
      "Engagement et régularité",
    ],
    why: [
      "Vivre une expérience de troupe complète (scène + compétition)",
      "Développer un fort esprit d'équipe",
      "Multiplier les occasions de se produire",
      "S'investir dans un projet artistique sur la durée",
    ],
  },

  "duo-solo-ido": {
    tagline: "L'exigence individuelle, sous les règles de la fédération IDO.",
    callout: {
      title: "Accès sur casting",
      text: "Inscription sous audition. Accès sur casting.",
    },
    intro: [
      "Discipline : hip-hop en compétition (règles IDO) · Tranches d'âge selon la catégorie IDO retenue.",
      "Ce cours prépare les danseurs à présenter des chorégraphies individuelles (solo) ou à deux (duo) en compétition, selon les règles de l'IDO (International Dance Organization). Un accompagnement personnalisé permet à chaque danseur de construire une performance qui lui ressemble, technique et expressive.",
    ],
    bases: [
      "Construction chorégraphique individuelle",
      "Technique approfondie et personnalisée",
      "Interprétation et expression scénique",
      "Connaissance des règles de jugement IDO",
    ],
    why: [
      "Se révéler en solo ou en duo",
      "Un suivi individualisé et sur mesure",
      "Développer sa propre signature artistique",
      "Compétitionner dans un cadre international reconnu",
    ],
  },

  "preparation-competition-junior": {
    tagline: "1 année de préparation aux compétitions hip-hop.",
    callout: {
      title: "Accès sur casting",
      text: "Inscription sous audition. Accès sur casting.",
    },
    intro: [
      "1 année de préparation aux compétitions hip-hop (on va voir les compétitions, on s'entraîne comme si on participe). On soutient les groupes de compétition officiels.",
      "Complémentaire à l'équipe Compétition Junior, ce cours cible le renforcement technique et l'immersion dans l'univers des compétitions — pour se préparer sereinement à intégrer les groupes de compétition officiels.",
    ],
    bases: [
      "Renforcement technique ciblé",
      "Répétition et affinement des mouvements",
      "Souplesse, force et endurance",
      "Suivi individualisé des progrès",
    ],
    why: [
      "Se préparer à intégrer les groupes de compétition officiels",
      "Vivre l'expérience des compétitions en tant que supporter",
      "Un accompagnement technique renforcé",
      "Gagner en confiance avant de compétitionner",
    ],
  },

  "reggaeton": {
    tagline: "Groove urbain et énergie latine — laisse-toi porter par le rythme du dembow.",
    intro: [
      "Né à Porto Rico et popularisé dans toutes les Caraïbes, le Reggaeton mélange les rythmes latinos, le hip-hop et le dancehall sur la pulsation caractéristique du dembow. Danse festive et énergique, elle met l'accent sur le groove, les isolations et la confiance en soi, dans une ambiance conviviale accessible à tous les niveaux.",
    ],
    bases: [
      "Groove et isolations du bassin",
      "Pas de base sur le rythme dembow",
      "Musicalité et énergie propres au reggaeton",
      "Confiance en soi et expression corporelle",
    ],
    why: [
      "Un défouloir festif et hyper énergique",
      "Accessible à tous les niveaux, aucun prérequis",
      "Développe le sens du rythme et la confiance en soi",
      "Une ambiance latine assurée à chaque cours",
    ],
  },

  "danse-parents-enfants": {
    tagline: "Un moment complice à partager, en musique et en mouvement.",
    intro: [
      "Conçu pour les tout-petits (2-5 ans) accompagnés d'un parent ou d'un adulte référent, ce cours transforme la découverte de la danse en moment de complicité partagée. À travers le jeu, la musique et le mouvement à deux, l'enfant explore son corps et le rythme en toute confiance, avec le soutien rassurant de l'adulte à ses côtés.",
    ],
    bases: [
      "Jeux moteurs et de mouvement à deux",
      "Découverte du rythme et de la musique en duo",
      "Motricité, équilibre et coordination de l'enfant",
      "Complicité et lien parent-enfant",
    ],
    why: [
      "Un moment privilégié à partager avec son enfant",
      "Premiers pas en douceur dans l'univers de la danse",
      "Stimule la motricité et la confiance de l'enfant",
      "Renforce le lien parent-enfant par le jeu",
    ],
  },

  "break-dance": {
    tagline: "Les racines du hip-hop — footwork, power moves et figures au sol.",
    intro: [
      "Discipline fondatrice du hip-hop née dans le Bronx, le Break Dance initie les enfants de 7 à 12 ans aux mouvements emblématiques de cette culture urbaine : footwork, power moves, freezes et figures au sol. Dans un cadre ludique et progressif, les jeunes danseurs développent force, coordination et confiance, tout en découvrant les racines historiques du hip-hop.",
    ],
    bases: [
      "Footwork (jeux de jambes au sol)",
      "Power moves et figures acrobatiques de base",
      "Freezes (arrêts sur image)",
      "Coordination, force et souplesse",
    ],
    why: [
      "Découvrir les racines authentiques du hip-hop",
      "Développer force, souplesse et coordination",
      "Une discipline physique et spectaculaire",
      "Booste la confiance en soi et l'esprit de défi",
    ],
  },

  "theatre": null, // removed — no longer offered

  "ballet-eveil": {
    tagline: "De 2 à 5 ans — les premiers pas vers la grâce et la musicalité.",
    intro: [
      "De 2 à 5 ans, ce parcours initie les tout-petits à l'univers du ballet en douceur, du Baby Ballet (2-4 ans) au Ballet Éveil (4-5 ans). À travers le jeu, la musicalité et la découverte des premières postures, les enfants développent grâce, coordination et confiance, dans un cadre ludique et bienveillant adapté à leur âge.",
    ],
    bases: [
      "Découverte du corps et des premières postures",
      "Musicalité et écoute du rythme",
      "Coordination et motricité",
      "Grâce et plaisir du mouvement",
    ],
    why: [
      "Une première approche douce et ludique du ballet",
      "Développe la motricité et la musicalité dès le plus jeune âge",
      "Un cadre bienveillant adapté aux tout-petits",
      "Prépare en douceur à la technique classique structurée (Classique 7-12 ans)",
    ],
  },

  "classique": {
    tagline: "7-12 ans — la technique du ballet classique, structurée et exigeante.",
    intro: [
      "Dès 7 ans, le cours de Classique permet aux enfants d'entrer dans la technique structurée du ballet : travail à la barre, positions codifiées et exercices au centre. Dans la continuité de Ballet & Éveil, ce cours plus exigeant développe rigueur, précision et discipline, tout en cultivant la grâce et la musicalité propres à la danse classique.",
    ],
    bases: [
      "Travail à la barre et positions de base",
      "Technique, alignement et placement du corps",
      "Exercices au centre et petits sauts",
      "Rigueur, discipline et musicalité",
    ],
    why: [
      "Construire une technique solide et durable",
      "Développe la rigueur et la concentration",
      "Une base précieuse pour toutes les danses futures",
      "Cultive la grâce et la précision du geste",
    ],
  },

  "contemporain": {
    tagline: "Le mouvement comme langage — émotions, fluidité, interprétation.",
    intro: [
      "La danse Contemporaine explore le mouvement comme moyen d'expression des émotions et des histoires. Mêlant fluidité, contrôle et improvisation, ce cours ouvert aux enfants comme aux adultes (selon niveaux) invite à travailler le corps en profondeur, à développer sa sensibilité artistique et à oser une interprétation sincère et personnelle.",
    ],
    bases: [
      "Fluidité et contrôle du mouvement",
      "Travail au sol et transitions",
      "Improvisation et interprétation",
      "Expression des émotions par le corps",
    ],
    why: [
      "Développer sa sensibilité artistique et sa créativité",
      "Travailler le corps en profondeur, en douceur",
      "Accessible aux enfants comme aux adultes selon niveaux",
      "Apprendre à raconter une émotion sans mots",
    ],
  },


};

export function getCourseDetail(slug) {
  return COURSE_DETAILS[slug] || null;
}
